import { frontendURL } from '../../../helper/URLHelper';

const ClaudiaLayout = () => import('../claudia/components/ClaudiaLayout.vue');
const EddieView = () => import('./pages/EddieView.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/eddie'),
      name: 'eddie_app',
      component: ClaudiaLayout,
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      children: [
        {
          path: '',
          redirect: 'view',
        },
        {
          path: 'view/:eddieId?',
          name: 'eddie_view',
          component: EddieView,
          meta: {
            permissions: ['administrator', 'agent', 'custom_role'],
          },
        },
      ],
    },
  ],
};
